<template>
  <div>
    <div class="branding">
      <div class="brand-wrapper">
        <a href=""> <img :src="businesslogo" alt="logo" class="logo"/></a>
      </div>
      <div v-if="finalisation">
        <finalisation-order
          :ref="'finalisationref'"
          :idshop="idshop"
          :redirect="redirect"
          @welaunchorder="gotLaunchOrder"
          :postdatafinal="datasfinal"
        ></finalisation-order>
      </div>
      <v-alert v-if="snackbaralert" outlined type="success" text>
        {{ end_message }}
      </v-alert>
      <p class="login-card-description text-center">{{ shopname }}</p>
      <div id="presentation" v-if="isdecription">
        <p class="seemore">
          <span v-html="currentdescription"></span>
          <a href="#" @click.prevent="toggledescription" class="seemore seea">
            {{ textactiondescription }}
          </a>
        </p>
      </div>

      <v-snackbar v-model="snackbardelivery" :timeout="timeoutSnackbarDelivery">
        {{ text_snackbardelivery }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="snackbardelivery = false"
          >
            fermer
          </v-btn>
        </template>
      </v-snackbar>
      <cart-box
        :colorinfos="colorinfos"
        :nbarticle="nb_items"
        :listcart="cart"
        @datasFromCartbox="gotDatafromCartbox"
        @articleToRemove="removeFromCartEmeted"
        ref="cartbox"
      ></cart-box>
    </div>
    <v-container>
      <v-row>
        <description-article  :describme="articleToDescrip"
         @getbackitemsFromDescription="sommeofquantitiesEmeted"
         @maxamountnotifFromDescription="showmaxamountnotif"
         :redirect="redirect"
         ></description-article>
        <v-col v-for="n in articles.length" :key="n" cols="12" sm="6" md="4">
          <single-article
            :ref="'article_' + articles[n - 1]['id']"
            @getbackitems="sommeofquantitiesEmeted"
            @maxamountnotif="showmaxamountnotif"
            @showmedescription="ShowTheDescription"
            :current_quantity="0"
            :details="articles[n - 1]"
            md="6"
            :redirect="redirect" :colorinfos="colorinfos"
          >
          </single-article>
          <hr />
        </v-col>
      </v-row>
    </v-container>
    <v-spacer></v-spacer>
    <div class="text-center">
      <v-btn
        xs4
        class="btn-spacer btn-finalisation"
        :disabled="nb_items < 1"
        :style="{color:colorinfos.textCartColor,background:colorinfos.buttonCartColor}"
        :color="colorinfos.buttonCartColor"
        @click.prevent="$refs.cartbox.dialogus = true"
        >finaliser ma commande</v-btn
      >
    </div>
    <div class="text-center ma-2"></div>
  </div>
</template>

<script>
import Article from "./article.vue";
import Cartbox from "./cartbox.vue";
import FinalisationOrder from "./finalisationorder.vue";
import DescriptionArticle from "./descriptionarticle.vue";

export default {
  title: "",
  components: {
    "single-article": Article,
    "cart-box": Cartbox,
    "finalisation-order": FinalisationOrder,
    "description-article": DescriptionArticle
  },
  props: {
    articles: Array,
    idshop: String,
    shopname: String,
    shopdescription: String,
    businesslogo: String,
    categorieslist: Array,
    redirect: String,
    end_message: String,
    text_snackbardelivery: String,
    colorinfos: Object
  },

  data() {
    return {
      snackbardelivery: false,
      timeoutSnackbarDelivery: 10000,
      text_snackbar: "",
      snackbaralert: false,
      multiLine: true,
      disablefinalorder: true,
      dictionnary: {
        title_card:
          "Passer rapidement votre commande en remplissant ce formulaire",
        sub_title_card: "Le nombre de commande par article est limité par jour",
        description_card: ""
      },
      end_message: "",
      show_alert: false,
      message_type: "success",
      alert_message: null,
      nb_items: 0,
      cart: [],
      hidden: false,
      finalisation: false,
      datasfinal: {},
      dalais_delivery: "+24h",
      price_livraison: 2000,
      colorgreen: "#00a65ad4",
      colorred: "#EF323D",
      moredescription: false,
      currentdescription: "",
      textactiondescription: "...(voir plus)",
      articleToDescrip: {},
      isdecription : true
    };
  },
  watch: {
    nb_items: (newval, oldval) => {
      console.log("nb_items watcher", newval);
      if (newval > 0) {
        this.disablefinalorder = true;
      } else {
        this.disablefinalorder = false;
      }
      console.log("disabledfinalisation", this.disablefinalorder);
    },

    shopdescription: function(valuedescription) {
      console.log("on watch shopdescription ==>", valuedescription);
      if ( _.isEmpty( valuedescription ) )
      {
          this.isdecription = false
      }
      this.currentdescription = valuedescription.slice(0, 200);
    }
  },
  mounted() {
    this.showSnackbardelivery();
  },
  methods: {
    showSnackbardelivery() {
      this.snackbardelivery = true;
    },
    toggledescription() {
      if (!this.moredescription) {
        this.textactiondescription = "...(voir plus)";
        this.currentdescription = this.shopdescription.slice(0, 200);
      } else {
        this.textactiondescription = "...(voir moin)";
        this.currentdescription = this.shopdescription;
      }

      this.moredescription = !this.moredescription;
    },
    removeAricleFunction(article) {
      _.remove(this.cart, function(elem) {
        return elem.id == article.id;
      });
    },
    ShowTheDescription(article) {
      this.articleToDescrip = article;
      console.log('ShowTheDescription ===>',article);
    },
    gotLaunchOrder(orderDetails) {
      //console.log("-----------THIS IS YOUR FINAL LAP----------");
      //console.log("Commande Finale", orderDetails);
      //console.log("--------------------------------------------");
      this.snackbaralert = true;
      //this.end_message =

      //console.log("this.$parent.$options.methods.getInfoShopFromSubdomain() zerr",this.$parent.$options.parent.getInfoShopFromSubdomain());
      this.$parent.$options.parent.getInfoShopFromSubdomain();

      window.scrollTo(0, 0);
    },
    pushInCart(obj) {
      let indexcart = _.findIndex(this.cart, function(o) {
        return o.id == obj.id;
      });
      if (indexcart < 0) {
        //('<---- isUndefined ---->');
        let article = _.find(this.articles, function(art) {
          return art.id == obj.id;
        });
        this.cart.push({
          id: obj.id,
          article: article,
          quantity: obj.quantity,
          total_price: article.pricing
        });
      } else {
        if (obj.quantity == 0) {
          // si la quantité est égal à 0 on le supprime de la cart
          this.removeAricleFunction(obj);
        } else {
          this.cart[indexcart]["quantity"] = obj.quantity;
          this.cart[indexcart]["total_price"] =
            parseInt(this.cart[indexcart]["article"]["pricing"]) *
            parseInt(obj.quantity);
        }
      }
      this.getNumberOfQuantities();
    },
    sommeofquantitiesEmeted(obj) {
      this.pushInCart(obj);
      this.$refs.cartbox.hidekyc();
    },
    showmaxamountnotif(notifmessage) {
      console.log("showmaxamountnotif ==>", notifmessage);
      if (notifmessage.snackbardelivery) {
        this.showSnackbardelivery();
        this.text_snackbardelivery = notifmessage.message;
      }
    },
    getNumberOfQuantities() {
      this.nb_items = _.sumBy(this.cart, "quantity");
    },
    removeFromCartEmeted(article) {
      this.removeAricleFunction(article);
      this.getNumberOfQuantities();
      this.$refs["article_" + article.id][0].emptyArticle();
    },
    gotDatafromCartbox(datas) {
      console.log("------------------REMONTADA---------------");
      console.log("gotDatafromCartbox", datas);
      console.log(
        "-----------<<<<<<------finalisationref---->>>>>> ----------------",
        this.$refs.finalisationref
      );
      if (!_.isUndefined(this.$refs.finalisationref)) {
        this.$refs.finalisationref.moveDialog();
        // = completename[1];
      }
      //this.$refs['finalisationref'][0].moveDialog();
      this.finalisation = true;

      this.datasfinal = {
        cart: this.cart,

        coordinates: {
          tel: datas.tel,
          firstname: datas.name,
          lastname: datas.lastname,
          email: datas.email,
          remember_me: datas.remember_me
        },

        delivery: {
          positionnable: datas.gotcoordinate,
          locationdetails: datas.findmyloc,
          adress_indication: datas.adress_indication,
          date_livraison: this.dalais_delivery,
          price_livraison: this.price_livraison
        }
      };
    }
  }
};
</script>

<style>
.branding {
  position: relative;
}
.presentation {
  position: relative;
  display: flex;
}
.seemore {
  position: relative;
  line-height: 2;
  display: inline-block;
}
.seea {
  color: #000000de !important;
  text-decoration: none !important;
  font-weight: bold !important;
}
.nb-article {
  font-weight: bold;
  font-size: 15px;
}
.btn-spacer {
  margin-bottom: 350px !important;
}
.btn-finalisation {
  /*color: #fff !important;*/
  font-weight: bold;
}
.logo {
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 25px;
  margin-bottom: 25px;
  min-width: 250px !important;
  min-height: 250px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pieces/kiosque.vue